// City-specific SEO landing page configuration.
// Each entry drives one landing page + JSON-LD schema.

export const CITIES = [
  {
    slug: "santa-rosa-beach-health-insurance",
    city: "Santa Rosa Beach",
    county: "Walton County",
    zip: "32459",
    lat: 30.3688,
    lng: -86.2401,
    intro:
      "Santa Rosa Beach sits at the heart of Scenic Highway 30A, from Blue Mountain Beach to Dune Allen. As your local insurance broker, Christian Regalado lives and works right here in Walton County — enrolling neighbors, second-home owners, and business owners into ACA, Medicare and supplemental plans that fit our unique coastal community.",
    landmarks:
      "From Grayton Beach State Park to Point Washington, Christian knows the ZIP codes, doctor networks, and local hospitals — including Ascension Sacred Heart Emerald Coast, Sacred Heart on the Emerald Coast, and Watersound Medical Group — that matter when you're comparing health plans.",
    localFaqs: [
      {
        q: "What health insurance carriers are available in Santa Rosa Beach, FL?",
        a: "The Walton County marketplace includes Florida Blue, Ambetter, Aetna, and Cigna for ACA plans, and Humana, UnitedHealthcare, Aetna, Devoted, WellCare, and Allstate for Medicare Advantage. We shop every one on your behalf.",
      },
      {
        q: "Is Christian a licensed Medicare broker in Walton County?",
        a: "Yes — Christian is a licensed independent health insurance broker in Florida (and Colorado) with 7+ years of experience serving 30A, Freeport, Point Washington, and the entire Walton County corridor.",
      },
      {
        q: "Do you meet clients in person on 30A?",
        a: "Absolutely. Christian meets clients in-person across Santa Rosa Beach, Watercolor, Seaside, Rosemary Beach, and Inlet Beach. Phone and video consultations are also available seven days a week.",
      },
    ],
  },
  {
    slug: "destin-medicare-broker",
    city: "Destin",
    county: "Okaloosa County",
    zip: "32541",
    lat: 30.3935,
    lng: -86.4958,
    intro:
      "Destin is one of Florida's fastest-growing retirement destinations, which means Medicare enrollment questions come up constantly. As a local independent Medicare broker, Christian Regalado helps Destin retirees and near-retirees compare Medicare Advantage and Medicare Supplement (Medigap) plans from every major carrier serving Okaloosa County — at no cost to you.",
    landmarks:
      "Whether you use Ascension Sacred Heart Emerald Coast, HCA Florida Twin Cities Hospital, or the Destin-area independent physician networks, Christian pulls up your exact doctor list and prescriptions before recommending a plan. He works clients from Kelly Plantation to Crystal Beach and everywhere in between.",
    localFaqs: [
      {
        q: "When can I enroll in a Medicare plan in Destin, FL?",
        a: "Your Initial Enrollment Period is the 7-month window around your 65th birthday. Annual Election runs Oct 15 – Dec 7, and Medicare Advantage Open Enrollment runs Jan 1 – Mar 31. Christian handles paperwork start-to-finish for Destin residents.",
      },
      {
        q: "What Medicare Advantage plans are available in Okaloosa County?",
        a: "Humana, UnitedHealthcare, Aetna, HealthSpring, Devoted, WellCare, and Allstate all offer Medicare Advantage plans in Destin. Several offer $0/month premium options with dental, vision and hearing benefits included.",
      },
      {
        q: "Do you help with Medicare Supplement (Medigap) plans in Destin?",
        a: "Yes — Medigap Plan G, Plan N and High-Deductible Plan G are the most common picks in Destin. Christian will run pricing for every carrier and identify which one has the best rate history for your age band.",
      },
    ],
  },
  {
    slug: "miramar-beach-health-insurance",
    city: "Miramar Beach",
    county: "Walton County",
    zip: "32550",
    lat: 30.3849,
    lng: -86.3554,
    intro:
      "Miramar Beach sits at the western edge of Walton County — a mix of primary residents, seasonal snowbirds, and hospitality workers. That means health insurance needs here are diverse: ACA marketplace plans for hourly workers and self-employed families, Medicare Advantage for retirees, and hospital indemnity plans to layer on top of high-deductible coverage. Christian handles all of it locally.",
    landmarks:
      "Christian regularly meets clients around Sandestin, Silver Shells, and along U.S. Highway 98. He works with the Ascension Sacred Heart Emerald Coast network and every major carrier serving the 32550 ZIP so you're never limited to a single provider list.",
    localFaqs: [
      {
        q: "Is ACA marketplace coverage available in Miramar Beach, FL?",
        a: "Yes. Florida Blue, Ambetter, Aetna and Cigna all sell ACA plans in Walton County. Most Miramar Beach households qualify for premium tax credits — Christian will run your subsidy in five minutes.",
      },
      {
        q: "Can I switch my current health plan mid-year?",
        a: "Only if you qualify for a Special Enrollment Period — moving to Miramar Beach, losing employer coverage, marriage, or a new baby all qualify. Christian handles the paperwork and effective-date coordination.",
      },
      {
        q: "Do you help self-employed 30A business owners?",
        a: "Yes. If you own a vacation rental, boat charter, contracting business or shop in Miramar Beach, Sandestin, or along 98, Christian specializes in getting self-employed households the maximum ACA subsidy.",
      },
    ],
  },
  {
    slug: "panama-city-beach-health-insurance",
    city: "Panama City Beach",
    county: "Bay County",
    zip: "32413",
    lat: 30.1766,
    lng: -85.8055,
    intro:
      "Panama City Beach is Bay County's largest market for health insurance — thanks to a mix of retirees moving in, tourism workers, and small business owners across Front Beach Road, Thomas Drive, and Pier Park. Christian is a licensed broker serving Bay County residents and works every major carrier on your behalf — no fees, no upsells.",
    landmarks:
      "Christian regularly helps PCB clients confirm their doctors are in-network at Ascension Sacred Heart Bay, HCA Florida Gulf Coast Hospital, and PanCare of Florida. From the Palms of Destin to Laguna Beach and Sunnyside, he pulls the right plans for the right ZIP.",
    localFaqs: [
      {
        q: "What Medicare plans are available in Panama City Beach, FL?",
        a: "Humana, UnitedHealthcare, Aetna, HealthSpring, Devoted, WellCare and Allstate offer Medicare Advantage in Bay County. Medicare Supplement plans (Medigap) are available with every major carrier — Christian shops the entire market for you.",
      },
      {
        q: "Can I get health insurance in PCB after losing my job?",
        a: "Yes. Losing employer coverage triggers a 60-day Special Enrollment Period on the ACA marketplace. Christian will compare a marketplace plan vs. a short-term plan side-by-side so you pick the least expensive bridge.",
      },
      {
        q: "Do you write dental and hospital indemnity plans in Bay County?",
        a: "Absolutely — standalone dental, cancer, hospital indemnity and final expense policies are common cross-sells in PCB. All are available at no additional broker cost to you.",
      },
    ],
  },
  {
    slug: "freeport-health-insurance",
    city: "Freeport",
    county: "Walton County",
    zip: "32439",
    lat: 30.4966,
    lng: -86.1358,
    intro:
      "Freeport is one of the fastest-growing towns in Northwest Florida — meaning new residents, new small businesses, and new Medicare-eligible families are moving in every month. Christian is your local independent insurance broker for the entire Walton County corridor, from Freeport up 331 to Hammock Bay and back down to 30A.",
    landmarks:
      "Christian meets Freeport clients in-person or by video, works with the Ascension Sacred Heart Emerald Coast network, and knows the Walton County provider directories inside and out — including primary care groups along U.S. Highway 20 and County Road 3280.",
    localFaqs: [
      {
        q: "Is health insurance more affordable in Freeport, FL?",
        a: "Rates in Freeport (32439) are competitive with the rest of Walton County. Most households qualify for meaningful ACA premium tax credits — Christian will run your household's subsidy for free.",
      },
      {
        q: "Do you help new residents moving to Freeport?",
        a: "Yes. Moving to Freeport counts as a qualifying life event, giving you a 60-day Special Enrollment Period to pick a new marketplace plan. Christian handles the effective-date paperwork so there's no gap in coverage.",
      },
      {
        q: "What Medicare Advantage plans work best in Freeport?",
        a: "Devoted Health, Humana, Aetna, UnitedHealthcare, HealthSpring, WellCare and Allstate all serve Walton County. Christian's job is to match you to the plan whose network includes your doctors and drug list — not the one that pays the highest commission.",
      },
    ],
  },
];

export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
